import React, { createContext, FC, useCallback, useContext, useEffect, useState } from 'react';
import { parentConnection, ParentConnectionEvent } from '../../../services/parentConnection';
import { ILoadingError } from './useLoadingErrorCatcher.types';
import { isNetworkError, isNotAuthorizedError, isUnknownLoadingError } from './useLoadingErrorCatcher.utils';

const LoadingErrorContext = createContext({
  loadingError: null,
  setLoadingError: null,
  resetLoadingError: null,
  isNotAuthorized: false,
  isUnknownLoadingError: false,
  isNetworkError: false,
});

export const LoadingErrorCatcherProvider: FC<{ loadingError?: ILoadingError }> = ({
  children,
  loadingError: _loadingError = null,
}) => {
  const [loadingError, setLoadingError] = useState(_loadingError);
  const resetLoadingError = useCallback(() => setLoadingError(null), []);

  const isNotAuthorized = isNotAuthorizedError(loadingError);
  const isNoNetworkAvailable = isNetworkError(loadingError);

  useEffect(() => {
    if (isNotAuthorized) {
      parentConnection.emit(ParentConnectionEvent.NotAuthorized);
    }
  }, [isNotAuthorized]);

  return (
    <LoadingErrorContext.Provider
      value={{
        loadingError,
        setLoadingError,
        resetLoadingError,
        isNotAuthorized,
        isNetworkError: isNoNetworkAvailable,
        isUnknownLoadingError: isUnknownLoadingError(loadingError),
      }}
    >
      {children}
    </LoadingErrorContext.Provider>
  );
};

export const useLoadingErrorCatcher = () => useContext(LoadingErrorContext);
